import axios from 'axios';

type ProgressStatus = 'done' | 'progress';

interface Progress {
  status: ProgressStatus;
  value: number;
}

const downloadFile = async (fileUrl: string, cb?: (progress: Progress) => void): Promise<Blob> => {
  const response = await axios.get(fileUrl, {
    responseType: 'blob',
    onDownloadProgress: (e) => {
      const value = 50 + Math.round((e.loaded * 100) / e.total / 2);
      cb &&
        cb({
          status: value === 100 ? 'done' : 'progress',
          value,
        });
    },
  });

  return response.data;
};

export const downloadFileToClient = async (
  fileUrl: string,
  fileName: string,
  cb?: (progress: Progress) => void,
): Promise<void> => {
  try {
    const response = await axios.get(fileUrl, {
      responseType: 'blob',
      onDownloadProgress: (e) => {
        if (e.total) {
          const value = Math.round((e.loaded * 100) / e.total);
          cb &&
            cb({
              status: value === 100 ? 'done' : 'progress',
              value,
            });
        }
      },
    });

    // Creëer een blob URL voor het bestand
    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    const url = window.URL.createObjectURL(blob);

    // Creëer een tijdelijk link element om het bestand te downloaden
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();

    // Clean up
    window.URL.revokeObjectURL(url);

    cb && cb({ status: 'done', value: 100 });
  } catch (error) {
    console.error('Download error:', error);
    throw error;
  }
};

export default downloadFile;
